<template>
  <div>
    <div 
      class="border-indigo-600 border rounded-xl h-5 w-9 flex items-center px-0.5 cursor-pointer transition duration-500"
      :class="{
        'border-opacity-25 bg-indigo-600 justify-end': mutableValue,
        'bg-white justify-start': !mutableValue,
      }"
      @click.stop="checkThat"
    >
      <div 
        class="rounded-full h-3 w-3"
        :class="{
          'bg-white': mutableValue,
          'bg-indigo-600': !mutableValue,
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    //
  },

  props:{
    name: String,
    value: Boolean,
    necessary: Boolean,
    disabled:{
      type: Boolean,
      required: false,
      default: false
    },
  },
  data: function () {
    return {
      mutableValue: this.value != undefined ? this.value : false,
      progressCount:true,
      disabled_pass: false,
    };
  },
  mounted(){
    // Manage edit permission for neopass pages
    if(this.$route.path.includes('form/neopass')){
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];
      if(this.$can(page+'_edit', idpass)){
        this.disabled_pass = false;
      }
      else{
        this.disabled_pass =  true;
      }
    }else{
      this.disabled_pass = false;
    }

    //assign "necessary" prop value to "progressCount" data if this prop is filled
    if(this.necessary != undefined && !this.necessary){
      this.progressCount = false;
    }
  },
  methods:{
    checkThat(){
      if(!this.disabled){
        this.$emit('input', !this.mutableValue);
        this.$emit('loseFocus');
      }
    },
  },
  watch: {
    value(){
      this.mutableValue = this.value;
    }
  }
};
</script>
